/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Render_Audio_Rendering_EventsInputs */



/**
* | output |
* | --- |
* | "Rendering {count} Selected Event(s)" |
*
* @param {Render_Audio_Rendering_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_rendering_events = /** @type {((inputs: Render_Audio_Rendering_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Rendering_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Rendu de ${i?.count} evenement(s) selectionne(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Rendering ${i?.count} Ausgewähltes(e) Ereignis(se)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rendering ${i?.count} Evento/i selezionato/i`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Отображение выбранного(ых) события(й) ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Representando ${i?.count} Evento(s) seleccionado(s)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`渲染 ${i?.count} 选定事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 選択されたイベントをレンダリングしています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`चयनित घटनाओं का रेंडरिंग ${i?.count}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Renderizando ${i?.count} Evento(s) selecionado(s)`)
	return /** @type {LocalizedString} */ (`Rendering ${i?.count} Selected Event(s)`)
});